import { Injectable } from '@angular/core';

import { DataService } from '../../data.service';
import { Observable } from 'rxjs';
import { NewSlots } from '../../shared/model';

@Injectable()
export class AvailabilityViewService {

    constructor(private dataService: DataService) { }

    getSupporterAvailabilities(email: string): Observable<any> {
        return this.dataService.get('Availability/GetSupporterAvailabilities', {userEmail: email});
    }

    addAvailabilitySlots(slots: NewSlots): Observable<any> {
        return this.dataService.post('Availability/AddAvailabilities', slots);
    }

    removeAvailabilitySlots(slots: number[]): Observable<any> {
        return this.dataService.delete('Availability/DeleteAvailabilities', {slots: slots});
    }

    getSupporterDetails(email: string): Observable<any> {
        return this.dataService.get('Supporter/GetSupporterDetails', {email: email});
    }

    getDisabledSpots(supporterId: string): Observable<any> {
        return this.dataService.get('Availability/GetDisabledSlots', {supporterId: supporterId});
    }

    notifySupporter(supporterId: string): Observable<any> {
        return this.dataService.post('Supporter/NotifySupporter', JSON.stringify(supporterId));
    }

    getFakeSlots(supporterId: string): Observable<any> {
        return this.dataService.get('Availability/GetSupporterMeetingsWithoutSlot', {supporterId: supporterId});
    }

    syncAvailabilityWithOutlook(supporterId: string): Observable<any> {
        return this.dataService.get('Availability/SendEmailForAvailabilities', {supporterId: supporterId});
    }
}
